import React from 'react';
import { MapPin, Phone, Mail, Facebook, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="premium-blue-soft text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <div className="mb-4">
              {/* Logo Image */}
              <img
                src="https://customer-assets.emergentagent.com/job_bureaux-prestige/artifacts/7wpomzap_Image1.png"
                alt="Esprit Ouest"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Votre espace de travail premium dans l'Ouest Parisien. 
              Confort, flexibilité et image professionnelle.
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#F8F8F5]/10 hover:bg-[#FFFFFF] rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="Facebook">

                <Facebook size={18} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#F8F8F5]/10 hover:bg-[#FFFFFF] rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="LinkedIn">

                <Linkedin size={18} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#F8F8F5]/10 hover:bg-[#FFFFFF] rounded-full flex items-center justify-center transition-colors duration-300"
                aria-label="Instagram">

                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-white font-bold">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('concept')}
                  className="text-gray-300 hover:text-white font-bold transition-colors">

                  Concept
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('espaces')}
                  className="text-gray-300 hover:text-white font-bold transition-colors">

                  Nos Espaces
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('lieux')}
                  className="text-gray-300 hover:text-white font-bold transition-colors">

                  Lieux
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('avantages')}
                  className="text-gray-300 hover:text-white font-bold transition-colors">

                  Avantages
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-white font-bold transition-colors">

                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Locations Column */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-white font-bold">Nos Sites</h4>
            <ul className="space-y-3">
              <li>
                <div className="flex items-start space-x-2">
                  <MapPin className="text-white font-bold flex-shrink-0 mt-1" size={16} />
                  <div>
                    <p className="font-semibold">Versailles</p>
                    <p className="text-sm text-gray-300">Boulevard de la Reine</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="flex items-start space-x-2">
                  <MapPin className="text-white font-bold flex-shrink-0 mt-1" size={16} />
                  <div>
                    <p className="font-semibold">Jouy-en-Josas</p>
                    <p className="text-sm text-gray-300">Rue du Petit Robinson</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="flex items-start space-x-2">
                  <MapPin className="text-white font-bold flex-shrink-0 mt-1" size={16} />
                  <div>
                    <p className="font-semibold">Viroflay</p>
                    <p className="text-sm text-gray-300">Rue des Vignes</p>
                  </div>
                </div>
              </li>
              <li>
                <div className="flex items-start space-x-2">
                  <MapPin className="text-white font-bold flex-shrink-0 mt-1" size={16} />
                  <div>
                    <p className="font-semibold">Le Neubourg (Normandie)</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-white font-bold">Contact</h4>
            <ul className="space-y-3">
              <li>
                <div className="flex items-center space-x-2">
                  <Phone className="text-white font-bold" size={16} />
                  <a
                    href="tel:+33240000000"
                    className="text-gray-300 hover:text-white font-bold transition-colors">01 71 42 72 15


                  </a>
                </div>
              </li>
              <li>
                <div className="flex items-center space-x-2">
                  <Mail className="text-white font-bold" size={16} />
                  <a
                    href="mailto:contact@espritouest.com"
                    className="text-gray-300 hover:text-white font-bold transition-colors">

                    contact@espritouest.com
                  </a>
                </div>
              </li>
            </ul>

            <div className="mt-6">
              <p className="text-sm text-gray-300 mb-2">Horaires d'ouverture :</p>
              <p className="text-sm text-gray-400">Lun-Ven : 9h - 18h</p>
              <p className="text-sm text-gray-400">Sam-Dim : Fermé</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Esprit Ouest. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/mentions-legales" className="text-gray-400 hover:text-white font-bold transition-colors">
                Mentions légales
              </a>
              <a href="/politique-confidentialite" className="text-gray-400 hover:text-white font-bold transition-colors">
                Politique de confidentialité
              </a>
              <a href="/cgv" className="text-gray-400 hover:text-white font-bold transition-colors">
                CGV
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;